import React from 'react'
import { Link } from 'react-router-dom'

//props = text, link
export default function Button(props) {
    return (
        <Link role='Button' className='btn btn-primary custom-btn mb-3 bg-blue' to={'/' + props.link}>
            {props.text}
        </Link>
    )
}